import { render, staticRenderFns } from "./ReporteAsignacionesUsuarioGrupos.vue?vue&type=template&id=83731ac8&"
import script from "./ReporteAsignacionesUsuarioGrupos.vue?vue&type=script&lang=js&"
export * from "./ReporteAsignacionesUsuarioGrupos.vue?vue&type=script&lang=js&"
import style0 from "./ReporteAsignacionesUsuarioGrupos.vue?vue&type=style&index=0&id=83731ac8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports